import type { FeedStats } from '../../lib/feed.js';

const EYEBROW_DATE = new Intl.DateTimeFormat('en-US', {
  weekday: 'long',
  month: 'short',
  day: 'numeric',
});

const plural = (count: number, one: string, many: string) =>
  `${count.toLocaleString()} ${count === 1 ? one : many}`;

export function FeedHeader({
  firstName,
  stats,
  caughtUp = false,
  now = new Date(),
}: {
  firstName: string | null;
  stats: FeedStats | undefined;
  /** Nothing unread on what the member follows. */
  caughtUp?: boolean;
  now?: Date;
}) {
  const followed = stats
    ? `the ${plural(stats.followed_accounts, 'account', 'accounts')} and ${plural(stats.followed_projects, 'project', 'projects')} you follow`
    : 'the accounts and projects you follow';
  return (
    <header>
      <p className="text-[10px] uppercase tracking-wide text-muted-foreground">
        Your week · {EYEBROW_DATE.format(now)}
      </p>
      <h1 className="mt-1.5 mb-1 text-2xl font-bold tracking-tight">
        {caughtUp
          ? `Congrats${firstName ? `, ${firstName}` : ''}! You're all caught up 🎉`
          : firstName
            ? `${firstName}, here's what changed.`
            : "Here's what changed."}
      </h1>
      <p className="text-sm text-muted-foreground">
        {caughtUp ? `Nothing new on ${followed}.` : `What changed on ${followed}.`}
      </p>
    </header>
  );
}
